import { labeled, boolean, stringRequired, custom } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  custom(Joi)
    .object()
    .keys({
      assistsWithInvestmentPurchases: boolean(Joi).label(
        labeled(
          label,
          'Assists with investment purchases and tax planning (no tax advice is being given)'
        )
      ),
      anticipatedVariableCashFlows: boolean(Joi).label(
        labeled(label, 'Anticipated variable cash flows')
      ),
      allowsAccessToFundsAtAnyTime: boolean(Joi).label(
        labeled(label, 'Allows access to funds at any time')
      ),
      flexibilityToManageRepayments: boolean(Joi).label(
        labeled(label, 'Flexibility to manage repayments')
      ),
      noNeedToApply: boolean(Joi).label(
        labeled(label, 'No need to apply for further lending in future')
      ),
      ongoingNeedForFunds: boolean(Joi).label(
        labeled(
          label,
          'Ongoing need for funds – planning to make a few purchases over a period of time'
        )
      ),
      other: boolean(Joi).label(labeled(label, 'Other'))
    })
    .orValue(
      'assistsWithInvestmentPurchases',
      'anticipatedVariableCashFlows',
      'allowsAccessToFundsAtAnyTime',
      'flexibilityToManageRepayments',
      'noNeedToApply',
      'ongoingNeedForFunds',
      'other'
    )
    .label(label)
    .when('.other', {
      is: true,
      then: Joi.object().keys({
        otherComments: stringRequired(Joi, 1, 4096).label(labeled(label, 'Details'))
      })
    });

export default {
  schema
};
